import * as Bowser from 'bowser'
const {parse} = Bowser
export function getDeviceInfo() {
    return parse(window.navigator.userAgent);
}
